var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 23,
    viewBox: "0 0 32 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.8333333,24.0833333 L16.8333333,14.9166667 L25.0833333,19.4999761 L16.8333333,24.0833333 Z M34.524507,11.9424881 C34.1653492,10.5963848 33.1126388,9.53526752 31.7776913,9.17278137 C29.338753,8.5 19.5829997,8.5 19.5829997,8.5 C19.5829997,8.5 9.82758757,8.5 7.38869798,9.14727564 C6.07939064,9.50936863 5.0009913,10.5965814 4.64183357,11.9424881 C4,14.4011625 4,19.5 4,19.5 C4,19.5 4,24.6246381 4.64183357,27.057561 C5.00138126,28.4034678 6.0537017,29.464585 7.38889296,29.8270712 C9.85327651,30.5 19.5833896,30.5 19.5833896,30.5 C19.5833896,30.5 29.338753,30.5 31.7776913,29.8527735 C33.1128338,29.4904839 34.1653492,28.4293667 34.5248969,27.0834599 C35.1666667,24.6246381 35.1666667,19.5258989 35.1666667,19.5258989 C35.1666667,19.5258989 35.1922245,14.4011625 34.524507,11.9424881 L34.524507,11.9424881 Z",
    transform: "translate(-4 -8)"
  })));
}

export default __webpack_public_path__ + "static/youtube-eda5d63440b8155a64cffbe34bc0cab3.svg";
export { SvgYoutube as ReactComponent };